import React, { useImperativeHandle, useMemo } from 'react';

import { Button, Grid } from '@mui/material';

import DashboardFilter from '@pharmaplan/common/assets/icons/dashboardFilter.svg';
import { dropdownMapper } from '@pharmaplan/common/helpers/utils';
import { adminSoftwareList } from '@pharmaplan/common';

import useAdminMapFilter from '../../../../../hooks/Admin/AdminFilters/useAdminMapFilter';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import CustomDropdown from '../../../../common/CustomDropdown';
import strings from '../../../../../localization';

import styles from './styles';

interface IAdminMapFilter {
  setFilterState: (
    value: React.SetStateAction<{
      submitted: boolean;
      showFilter: boolean;
    }>
  ) => void;
  filterState: {
    submitted: boolean;
    showFilter: boolean;
  };
}

const AdminMapFilter = React.forwardRef(
  ({ filterState, setFilterState }: IAdminMapFilter, ref) => {
    const softwares = useAppSelector(adminSoftwareList);

    const dropdownSoftwares = useMemo(
      () =>
        dropdownMapper(softwares, 'softwareId', 'name'),
      [softwares],
    );

    const { formik, resetFilter } = useAdminMapFilter({
      filterState,
      setFilterState,
    });

    useImperativeHandle(ref, () =>
      ({
        reset() {
          resetFilter();
        },
        clear() {
          formik.resetForm();
        },
      }));

    return (
      <Grid
        container
        sx={styles.container}
        xs={12}
        component="form"
        onSubmit={formik.handleSubmit}
      >
        <Grid item xs={3}>
          <CustomDropdown
            menuItems={dropdownSoftwares}
            formik={formik}
            label={strings.software}
            name="softwareId"
          />
        </Grid>
        <Grid sx={styles.submitButtonContainer} item>
          <Button
            variant="contained"
            style={styles.submitButton}
            type="submit"
          >
            <img src={DashboardFilter} alt={strings.submit} />
          </Button>
        </Grid>
      </Grid>
    );
  },
);

export default AdminMapFilter;
